// Routes and the frame. Board and bench are chrome-free (no menu, no toolbar);
// everything else sits in Ionic's split pane. Nothing renders until /api/me
// answers; a 401 shows the sign-in page.
import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, useLocation } from "react-router-dom";
import { ChangesPoller, MeProvider, useMe } from "./api/live";
import { Menu } from "./shell/Menu";
import { Loading } from "./shell/ui";
import { SignInPage } from "./pages/SignInPage";
import { AccountPage } from "./pages/AccountPage";
import { WeekPage } from "./pages/WeekPage";
import { BoardPage } from "./pages/BoardPage";
import { BenchPage } from "./pages/BenchPage";
import { ShelvesPage } from "./pages/ShelvesPage";
import { TasksPage } from "./pages/TasksPage";
import { StatsPage } from "./pages/StatsPage";
import { SkillsPage } from "./pages/SkillsPage";
import { ReviewPage } from "./pages/ReviewPage";
import { SettingsPage } from "./pages/SettingsPage";

setupIonicReact({ mode: "ios" });

const CHROME_FREE = ["/board", "/bench"];

function Frame() {
  const { pathname } = useLocation();
  const { status, error, reload } = useMe();
  if (pathname.startsWith("/account")) return <AccountPage />;
  if (status === "loading") return <Loading what="Opening the planner" />;
  if (status === "out") return <SignInPage returnTo={pathname} />;
  if (status === "error") return (
    <div className="signin"><div className="card"><h1>The planner can't be reached</h1><p>{error}</p>
      <button type="button" className="btn btn--primary btn--lg" onClick={reload}>Try again</button></div></div>
  );
  const bare = CHROME_FREE.some((p) => pathname.startsWith(p));
  return (
    <>
      <ChangesPoller />
      <IonSplitPane contentId="main" when="lg" disabled={bare}>
        <Menu />
        <IonRouterOutlet id="main">
          <Route path="/week" exact component={WeekPage} />
          <Route path="/board" exact component={BoardPage} />
          <Route path="/bench" exact component={BenchPage} />
          <Route path="/shelves" exact component={ShelvesPage} />
          <Route path="/tasks" exact component={TasksPage} />
          <Route path="/stats" exact component={StatsPage} />
          <Route path="/skills" exact component={SkillsPage} />
          <Route path="/review" exact component={ReviewPage} />
          <Route path="/settings" exact component={SettingsPage} />
          <Route path="/" exact render={() => <Redirect to="/week" />} />
        </IonRouterOutlet>
      </IonSplitPane>
    </>
  );
}

export default function App() {
  return (
    <IonApp>
      <MeProvider>
        <IonReactRouter>
          <Frame />
        </IonReactRouter>
      </MeProvider>
    </IonApp>
  );
}
